var map = {
	"./address.js": "./src/api/schemas/address.js",
	"./addressTimezone.js": "./src/api/schemas/addressTimezone.js",
	"./agency.js": "./src/api/schemas/agency.js",
	"./agencyAccountBranch.js": "./src/api/schemas/agencyAccountBranch.js",
	"./agencyAccountDetail.js": "./src/api/schemas/agencyAccountDetail.js",
	"./agencyAllocationWorker.js": "./src/api/schemas/agencyAllocationWorker.js",
	"./agencyShift.js": "./src/api/schemas/agencyShift.js",
	"./agencyShiftAssignment.js": "./src/api/schemas/agencyShiftAssignment.js",
	"./approveListing.js": "./src/api/schemas/approveListing.js",
	"./area.js": "./src/api/schemas/area.js",
	"./bulkMessage.js": "./src/api/schemas/bulkMessage.js",
	"./bulkOffer.js": "./src/api/schemas/bulkOffer.js",
	"./bureauResourcesCompany.js": "./src/api/schemas/bureauResourcesCompany.js",
	"./country.js": "./src/api/schemas/country.js",
	"./dashboard.js": "./src/api/schemas/dashboard.js",
	"./employer.js": "./src/api/schemas/employer.js",
	"./employerAccount.js": "./src/api/schemas/employerAccount.js",
	"./employerAccountInvitation.js": "./src/api/schemas/employerAccountInvitation.js",
	"./employerBulkBreak.js": "./src/api/schemas/employerBulkBreak.js",
	"./index.js": "./src/api/schemas/index.js",
	"./index.test.js": "./src/api/schemas/index.test.js",
	"./industry.js": "./src/api/schemas/industry.js",
	"./internalWorkerInvitation.js": "./src/api/schemas/internalWorkerInvitation.js",
	"./job.js": "./src/api/schemas/job.js",
	"./jobCandidate.js": "./src/api/schemas/jobCandidate.js",
	"./lightVenues.js": "./src/api/schemas/lightVenues.js",
	"./listing.js": "./src/api/schemas/listing.js",
	"./listingOffer.js": "./src/api/schemas/listingOffer.js",
	"./listingOverview.js": "./src/api/schemas/listingOverview.js",
	"./listingPayRate.js": "./src/api/schemas/listingPayRate.js",
	"./listingTemplate.js": "./src/api/schemas/listingTemplate.js",
	"./message.js": "./src/api/schemas/message.js",
	"./multiple_booking.js": "./src/api/schemas/multiple_booking.js",
	"./noShowReason.js": "./src/api/schemas/noShowReason.js",
	"./nonSyftExperience.js": "./src/api/schemas/nonSyftExperience.js",
	"./payRate.js": "./src/api/schemas/payRate.js",
	"./permission.js": "./src/api/schemas/permission.js",
	"./reason.js": "./src/api/schemas/reason.js",
	"./report.js": "./src/api/schemas/report.js",
	"./reportType.js": "./src/api/schemas/reportType.js",
	"./role.js": "./src/api/schemas/role.js",
	"./shift.js": "./src/api/schemas/shift.js",
	"./skill.js": "./src/api/schemas/skill.js",
	"./timesheet.js": "./src/api/schemas/timesheet.js",
	"./uniform.js": "./src/api/schemas/uniform.js",
	"./user.js": "./src/api/schemas/user.js",
	"./venue.js": "./src/api/schemas/venue.js",
	"./worker.js": "./src/api/schemas/worker.js",
	"./workerRole.js": "./src/api/schemas/workerRole.js",
	"./workerVenue.js": "./src/api/schemas/workerVenue.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/api/schemas sync \\.js$";